import { createFileRoute } from '@tanstack/react-router'
import { ProfileSettingsPage } from '@/features/settings/profile/pages/profile-settings-page'

export const Route = createFileRoute('/_authenticated/profile/')({
  component: ProfileSettingsPage,
})
